import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col items-center gap-2 text-center" };
const _hoisted_2 = { class: "flex flex-col gap-0.5" };
const _hoisted_3 = ["id"];
const _hoisted_4 = ["id"];
const _hoisted_5 = { class: "flex items-center gap-4" };
import { useId } from "vue";
import { Button, Modal } from "@eudonet/opal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OverwriteConfirmModal',
    props: {
        modelValue: { type: Boolean }
    },
    emits: ["accept", "cancel"],
    setup(__props) {
        const titleId = useId();
        const descriptionId = useId();
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                "model-value": __props.modelValue,
                size: "xs",
                "show-header": false,
                "footer-position": "center",
                "aria-labelledby": _unref(titleId),
                "aria-describedby": _unref(descriptionId),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = (v) => !v && _ctx.$emit('cancel'))
            }, {
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_unref(Button), {
                            variant: "secondary",
                            label: _ctx.$t('organisation.create.overwriteWarning.cancel'),
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('cancel')))
                        }, null, 8 /* PROPS */, ["label"]),
                        _createVNode(_unref(Button), {
                            variant: "primary",
                            label: _ctx.$t('organisation.create.overwriteWarning.accept'),
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('accept')))
                        }, null, 8 /* PROPS */, ["label"])
                    ])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "size-12 rounded-lg border border-(--border-border-base-soft) bg-(--background-background-white) flex items-center justify-center shrink-0" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 28 28",
                                fill: "none",
                                "aria-hidden": "true",
                                class: "size-7 text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                            }, [
                                _createElementVNode("path", {
                                    d: "M15.01 3.5l11.114 19.25a1.167 1.167 0 0 1-1.01 1.75H2.887a1.167 1.167 0 0 1-1.011-1.75L12.99 3.5a1.167 1.167 0 0 1 2.02 0Z",
                                    class: "fill-(--colors-icon-warning-yellow)"
                                }),
                                _createElementVNode("path", {
                                    d: "M12.833 10.5h2.334v5.833h-2.334zm0 8.167h2.334V21h-2.334z",
                                    fill: "currentColor"
                                })
                            ])
                        ], -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("span", {
                                id: _unref(titleId),
                                class: "font-bold text-xl leading-6 text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                            }, _toDisplayString(_ctx.$t("organisation.create.overwriteWarning.title")), 9 /* TEXT, PROPS */, _hoisted_3),
                            _createElementVNode("span", {
                                id: _unref(descriptionId),
                                class: "text-base leading-6 text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                            }, _toDisplayString(_ctx.$t("organisation.create.overwriteWarning.message")), 9 /* TEXT, PROPS */, _hoisted_4)
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["model-value", "aria-labelledby", "aria-describedby"]));
        };
    }
});
